"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FILTER_WINDOW_SUBMIT_BUTTON = exports.FILTER_WINDOW_MOBILE_DIALOG = exports.FILTER_WINDOW_CLEAR_BUTTON = exports.FILTER_WINDOW = void 0;
const FILTER_WINDOW_MOBILE_DIALOG = exports.FILTER_WINDOW_MOBILE_DIALOG = 'filter-window-mobile-dialog';
const FILTER_WINDOW_SUBMIT_BUTTON = exports.FILTER_WINDOW_SUBMIT_BUTTON = 'filter-window-submit-button';
const FILTER_WINDOW_CLEAR_BUTTON = exports.FILTER_WINDOW_CLEAR_BUTTON = 'filter-window-clear-button';
const FILTER_WINDOW = exports.FILTER_WINDOW = 'filter-window';
